// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
    brandName: "Shri Bhagyavanti College,Indi",
    contact: "+91 9880879421,8867666236 | bhagyavanticollege@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/shree_bhagyavanti_institute/",
      whatsapp:   "https://wa.me/yourwhatsapplink",
      youtube:    "https://www.youtube.com/watch?v=1NnAFEYhQms",
      facebook:   "https://www.facebook.com/chadu1212/",
      twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
